
export default {
  name: 'SportDefaultPage',
  values: {
    sports: {
      default: [
        'Competitions',
        'Highlights',
        'Matches',
        'Outrights',
      ],
    },
  },
  meta: {
    extendable: true,
  },
}
